(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name sageFlightDataReport.controller:SageFlightDataReportCtrl
   *
   * @description
   *
   */
  angular.module('sageFlightDataReport')
    .controller('SageFlightDataReportCtrl', SageFlightDataReportCtrl);

  function SageFlightDataReportCtrl(CommonMasterData, $sce, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'SageFlightDataReportCtrl';
    vm.regex = "/^-?[0-9][^\.]*$/";
    vm.model = {
      searchPanelToggle : true,
      searchCriteria : {
        fromDate : null,
        toDate : null,
        fromTime : '00:00',
        toTime : '23:59',
        origin : null,
        destination : null,
        flightStatus : null,
        diverted : null,
        depTaxiTime : null,
        arrTaxiTime : null,
        operationMode :null
      },
      masterList : {
        airportList : [],
        flightStatusList : [],
        divertedStatusList : [],
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false,
        fromDateAfterToDate : false,
        fromTimeInvalid : false,
        toTimeInvalid : false,
        operationModeList :[{'operationModeDec': 'Departure', 'operationModeCode':'Departure'}, {'operationModeDec': 'Arrival', 'operationModeCode':'Arrival'} ]
      },
      initialSearchDone : false,
      reportDataURL : null,
      reportServerBaseUrl : null
    };

    // toggle search
    vm.clickOnSearch = function() {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    // submit search
    vm.submitSearch = function(params) {
      searchFlightBlockTimeReport(params);
    };

    // when change field in search
    vm.changeSearchField = function(searchParams, flag) {
      setDateValidationFlags();
      // if from date time before to date time
      if (!!vm.model.searchCriteria.fromDate
        && !!vm.model.searchCriteria.fromTime
        && !!vm.model.searchCriteria.toDate
        && !!vm.model.searchCriteria.toTime
        && !vm.model.masterList.fromDateFormatInvalid
        && !vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromTimeInvalid
        && !vm.model.masterList.toTimeInvalid
        && !isFromDateBeforeToDate()) {
        vm.model.masterList.fromDateAfterToDate = true;
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }
    };

    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }
      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
      // if from time invalid
      if (!isValidTime(vm.model.searchCriteria.fromTime)) {
        vm.model.masterList.fromTimeInvalid = true;
      } else {
        vm.model.masterList.fromTimeInvalid = false;
      }
      // if from time invalid
      if (!isValidTime(vm.model.searchCriteria.toTime)) {
        vm.model.masterList.toTimeInvalid = true;
      } else {
        vm.model.masterList.toTimeInvalid = false;
      }
    }

    // check from date and to date
    function isFromDateBeforeToDate() {
      return moment(
        vm.model.searchCriteria.fromDate + " "
        + vm.model.searchCriteria.fromTime,
        "DD/MM/YYYY HH:mm").isBefore(
        moment(vm.model.searchCriteria.toDate + " "
          + vm.model.searchCriteria.toTime,
          "DD/MM/YYYY HH:mm"));
    }
    ;
    // validate Date
    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    // validate time
    function isValidTime(time) {
      var regex = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/;
      return regex.test(time);
    }
    ;

    // search Flight Block Time report
    function searchFlightBlockTimeReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;
      }
      var url = CommonLogicService.getReportUrl('sage_flight_blk_time_report.rptdesign',
        getSearchParamMap(param));
      vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
    }

    // set search param map
    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
      searchParamMap["fromTime"] = param.fromTime;
      searchParamMap["toTime"] = param.toTime;
      searchParamMap["origin"] = '';
      if (!!param.origin && !!param.origin.airPortCode) {
        searchParamMap["origin"] = param.origin.airPortCode;
      }
      searchParamMap["destination"] = '';
      if (!!param.destination && !!param.destination.airPortCode) {
        searchParamMap["destination"] = param.destination.airPortCode;
      }
      searchParamMap["flightStatus"] = '';
      if (!!param.flightStatus && !!param.flightStatus.flightStatusCode) {
        searchParamMap["flightStatus"] = param.flightStatus.flightStatusCode;
      }
      searchParamMap["diverted"] = '';
      if (!!param.diverted && !!param.diverted.divertedStatusCode) {
        searchParamMap["diverted"] = param.diverted.divertedStatusCode;
      }
      searchParamMap["depTaxiTime"] = '';
      if (!!param.depTaxiTime) {
        searchParamMap["depTaxiTime"] = param.depTaxiTime;
      }
      searchParamMap["arrTaxiTime"] = '';
      if (!!param.arrTaxiTime) {
        searchParamMap["arrTaxiTime"] = param.arrTaxiTime;
      }
      searchParamMap["operationMode"] = '';
      if (!!param.operationMode) {
        searchParamMap["operationMode"] = param.operationMode.operationModeCode;
      }

      return searchParamMap;
    }

    function isValidSearchParams(params) {
      setDateValidationFlags();
      // if date invalid
      if (!!vm.model.searchCriteria.fromDate
        && !!vm.model.searchCriteria.fromTime
        && !!vm.model.searchCriteria.toDate
        && !!vm.model.searchCriteria.toTime) {
        if (vm.model.masterList.toDateFormatInvalid
          || vm.model.masterList.fromTimeInvalid
          || vm.model.masterList.fromDateFormatInvalid
          || vm.model.masterList.toTimeInvalid
          || vm.model.masterList.fromDateAfterToDate) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    }

    (function() {
      // load airport list
      CommonMasterData.getAirportList(function(airportList) {
        vm.model.masterList.airportList = airportList;
      }, function(error) {
        console.log('Airport List retrieval error!!!');
      });
      // load Flight Status list
      CommonMasterData.getFlightStatusList(function(flightStatusList) {
        vm.model.masterList.flightStatusList = flightStatusList;
      }, function(error) {
        console.log('Flight Status List retrieval error!!!');
      });// divertedList
      // load Flight Status list
      CommonMasterData
        .getDivertedStatusList(
          function(divertedStatusList) {
            vm.model.masterList.divertedStatusList = divertedStatusList;
          },
          function(error) {
            console
              .log('Diverted Status List retrieval error!!!');
          });
    })();
  }
}());
